export const requestIdHeader = 'x-api-request-id';
export const apolloTraceIdHeader = 'apollo-trace-id';
